// extracted by mini-css-extract-plugin
var _1 = "RentalPortalMatchCriteriaPopoverCriteria-moduleRentalPortalMatchCriteriaPopoverCriteria__XIocR";
var _2 = "RentalPortalMatchCriteriaPopoverCriteria-modulecolumnTitle__iy6Uf";
export { _1 as "RentalPortalMatchCriteriaPopoverCriteria", _2 as "columnTitle" }
